import { BaseService } from './BaseService';
import { UserNote } from '../types';

class NoteService extends BaseService {
  constructor() {
    super('/api/notes');
  }

  async getNotesForDocument(documentId: string | number): Promise<UserNote[]> {
    try {
      const items = await this.get<any[]>(`/document/${documentId}`);
      if (!Array.isArray(items)) return [];
      return items.map(i => this.mapNote(i));
    } catch (error) {
      console.error('NoteService.getNotesForDocument error', error);
      return [];
    }
  }

  async saveNoteForDocument(documentId: string | number, content: string): Promise<UserNote> {
    const data = await this.post<any>('', { documentId, content });
    return this.mapNote(data);
  }

  async getMyNotes(): Promise<UserNote[]> {
    try {
      const items = await this.get<any[]>('/my');
      if (!Array.isArray(items)) return [];
      return items.map(i => this.mapNote(i));
    } catch (error) {
      console.error('NoteService.getMyNotes error', error);
      return [];
    }
  }

  async deleteNoteById(noteId: string | number): Promise<boolean> {
    try {
      await this.delete(`/${noteId}`);
      return true;
    } catch (error) {
      console.error('NoteService.deleteNoteById error', error);
      return false;
    }
  }

  private mapNote(item: any): UserNote {
    return {
      id: item.id || item.Id,
      documentId: String(item.documentId || item.DocumentId),
      documentTitle: item.documentOfficialTitle || item.DocumentOfficialTitle,
      referenceNumber: item.documentReferenceNumber || item.DocumentReferenceNumber,
      content: item.content || item.Content,
      updatedAt: item.lastModifiedOn || item.LastModifiedOn || item.createdOn || item.CreatedOn
    };
  }
}

export const noteService = new NoteService();
